export default "__VITE_ASSET__BrouwW3z__"